import { useState, useEffect } from 'react'
import { WhichWeightAPI } from 'WhichWeightAPI'
import moment from 'moment'

import ContentFrame from 'components/Frame/ContentFrame'

export default function AthleteAppFeedbackFormTab() {

    const [feedbackData, setFeedbackData] = useState(null)

    const GetUserFeedbackFromBackend = async () => {

        const jsonBody = {
            source: 'feedback-modal'
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('REPORTING', 'GET', '/all_user_feedback', jsonBody)

        // console.log(result)

        setFeedbackData(result.data.data)
    }

    const OpenAthleteProfileInNewTab = (athleteId) => {
        const url = `/athlete/${athleteId}`
        window.open(url, '_blank')
    }

    useEffect(() => {
        GetUserFeedbackFromBackend()
    }, [])

    if (feedbackData === null) {
        return (
            <>
                <div className='w-full h-[800px] bg-gray-200 rounded-lg animate-pulse' />
            </>
        )
    }

    return (
        <div className='space-y-1'>
            <div className='grid grid-cols-3'>
                <p className='text-center text-sm text-gray-500'>Athlete</p>
                <p className='text-center text-sm text-gray-500'>Note</p>
                <p className='text-center text-sm text-gray-500'>Date</p>
            </div>

            <ContentFrame>
                <div className="text-center divide-y divide-gray-200">
                    {feedbackData.map((feedback) => (
                        <div
                            key={feedback.id}
                            className="grid grid-cols-3 divide-x divide-gray-200"
                        >
                            <div 
                                className="p-2 space-y-1 overflow-x-auto cursor-pointer hover:bg-gray-100"
                                onClick={() => OpenAthleteProfileInNewTab(feedback.userId)}
                            >
                                <div className='text-sm'>{feedback.firstName} {feedback.lastName}</div>
                                <div className='text-xs text-gray-500'>{feedback?.email?.length > 0 ? feedback.email : 'No Email'}</div>
                            </div>

                            <div className="flex items-center justify-center p-2 text-sm">
                                {feedback.additionalNote}
                            </div>

                            <div className="flex items-center justify-center p-2 text-sm">
                                {moment.utc(feedback.createdDate).local().format('MMMM DD, YYYY hh:mm A')}
                            </div>
                        </div>
                    ))}
                </div>
            </ContentFrame>
        </div>
    )
}